module.exports = __webpack_public_path__ + "img/pnMessage.6ac19f46.png";